import { render, staticRenderFns } from "./ProjectResource.vue?vue&type=template&id=865e1f88"
import script from "./ProjectResource.vue?vue&type=script&lang=js"
export * from "./ProjectResource.vue?vue&type=script&lang=js"
import style0 from "./ProjectResource.vue?vue&type=style&index=0&id=865e1f88&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports